import { useSpaceDappStore } from './use-space-dapp-store';
// a hook to create a SpaceDapp instance outside of the client SDK
export const useSpaceDapp = ({ provider, config, }) => {
    // pass the props to the store to initialize it
    // the store will create a new SpaceDapp instance if it doesn't already exist
    // or return the existing instance if it does
    const spaceDapp = useSpaceDappStore((state) => state.spaceDapp, provider, config);
    return spaceDapp;
};
//# sourceMappingURL=use-space-dapp.js.map